export var ButtonGraphicsDecorationType;
(function (ButtonGraphicsDecorationType) {
    ButtonGraphicsDecorationType["FollowDefault"] = "default";
    ButtonGraphicsDecorationType["TopBar"] = "topbar";
    // BottomBar = 'bottombar', // Future
    ButtonGraphicsDecorationType["Border"] = "border";
    ButtonGraphicsDecorationType["None"] = "none";
})(ButtonGraphicsDecorationType || (ButtonGraphicsDecorationType = {}));
export var ButtonGraphicsShowStatusIcons;
(function (ButtonGraphicsShowStatusIcons) {
    ButtonGraphicsShowStatusIcons["FollowDefault"] = "default";
    ButtonGraphicsShowStatusIcons["ShowAll"] = "all";
    ButtonGraphicsShowStatusIcons["None"] = "none";
})(ButtonGraphicsShowStatusIcons || (ButtonGraphicsShowStatusIcons = {}));
export var ButtonGraphicsElementUsage;
(function (ButtonGraphicsElementUsage) {
    ButtonGraphicsElementUsage["Automatic"] = "auto";
    ButtonGraphicsElementUsage["Text"] = "text";
    ButtonGraphicsElementUsage["Color"] = "color";
    ButtonGraphicsElementUsage["Image"] = "image";
})(ButtonGraphicsElementUsage || (ButtonGraphicsElementUsage = {}));
//# sourceMappingURL=StyleModel.js.map